import React from "react";
import {
  SCALE_TYPES,
  typeProgress,
  patternString,
  MASTERY_MAX,
} from "../../lib/numberSenseV2";
import { Icon, Keys } from "../numberSenseUi";

/* ============================================================
   Number Sense v2 — home. One card per scale *type* (the units of
   v2): its step pattern, how many keys you've leveled/crowned, and
   learn/drill actions. No per-key units — keys are picked at drill
   time, which is the whole point of v2.
   ============================================================ */

const HomeScreen = ({ progress, onLearn, onDrill }) => (
  <div className="ns-root">
    <div className="ns-app">
      <div className="topbar">
        <div className="brandmark">
          <b>number sense v2</b>
          <small>one pattern, twelve keys</small>
        </div>
        <div className="stat streak">
          <Icon name="flame" />
          {progress.streak}
        </div>
        <div className="stat xp">
          <Icon name="bolt" />
          {progress.xp}
        </div>
      </div>
      <div className="scroll">
        <div className="hero">
          <h1>
            learn the scale once.
            <br />
            own it in every key.
          </h1>
          <p>
            Each scale type is a single recipe of steps — so v2 teaches the
            recipe, then drills it in whichever key you pick. Level a key to{" "}
            {MASTERY_MAX} to crown it.
          </p>
          <a className="ns-xref" href="/number-sense">
            miss the classic chord-by-chord course? number sense v1 →
          </a>
        </div>

        {SCALE_TYPES.map((type) => {
          const p = typeProgress(progress.mastery, type);
          return (
            <div className="unit v2-type" key={type.id}>
              <div className="unit-head">
                <div>
                  <div className="ttl">{type.title}</div>
                  <div className="sub">{type.gloss}</div>
                </div>
                <button
                  className="unit-learn"
                  onClick={() => onLearn(type)}
                  aria-label={`learn: ${type.title}`}
                >
                  <Icon name="book" />
                  learn
                </button>
              </div>
              <div className="v2-type-row">
                <span className="v2-type-pattern mono">{patternString(type)}</span>
                <span className="v2-type-progress">
                  {p.crowned > 0 && (
                    <span className="v2-crowns">
                      <Icon name="trophy" /> {p.crowned}
                    </span>
                  )}
                  {p.leveled}/{p.total} keys
                </span>
              </div>
              <button className="btn v2-drill-btn" onClick={() => onDrill(type)}>
                drill it
              </button>
            </div>
          );
        })}

        <div className="footnote">
          <Keys />
          <br />
          number sense v2 — scales as recipes, keys on demand
        </div>
      </div>
    </div>
  </div>
);

export default HomeScreen;
